import useTranslation from 'shared/hooks/useTranslation';
import DotSection from 'shared/components/DotSection/DotSection';
import { Section } from 'shared/components/DotSection/Styled';
import HeaderSection from '../HeaderSection';

function OrganicTaffic(): JSX.Element {
  const { t, lang } = useTranslation('collectingReviewsPage');

  const NAVIGATION_REVIEWS = [
    {
      id: 1,
      header: t('scrollSection.createMassage.setTitleHeader'),
      description: t('scrollSection.createMassage.setTitleDesctiption'),
    },
    {
      id: 2,
      header: t('scrollSection.createMassage.styleMailHeader'),
      description: t('scrollSection.createMassage.styleMailDescription'),
    },
    {
      id: 3,
      header: t('scrollSection.createMassage.sendOptionHeader'),
      description: t('scrollSection.createMassage.sendOptionDescription'),
    },
  ];

  const CONTENT_IMAGES = [
    {
      src: `/img/collecting-reviews/${lang === 'pl' ? 'pl' : 'en'}/invitation-on-email.png`,
      width: 1031,
      height: 525,
    },
    {
      src: `/img/collecting-reviews/${lang === 'pl' ? 'pl' : 'en'}/reviews-on-phone.png`,
      width: 725,
      height: 678,
    },
    {
      src: `/img/collecting-reviews/${lang === 'pl' ? 'pl' : 'en'}/calendar.png`,
      width: lang === 'pl' ? 600 : 708,
      height: lang === 'pl' ? 425 : 533,
    },
  ];

  return (
    <Section>
      <HeaderSection
        header={t('scrollSection.createMassage.topText' as const)}
        topHeader={t('scrollSection.createMassage.topHeader' as const)}
        description={t('scrollSection.createMassage.description' as const)}
      />
      <DotSection navigationItems={NAVIGATION_REVIEWS} images={CONTENT_IMAGES} />
    </Section>
  );
}

export default OrganicTaffic;
